import React from 'react';
import Icon from '../../../../core/Icon';
import DefaultObjectFormatter from './ObjectFormatter';
var bp = ['xs', 'sm', 'md', 'lg', 'xl'];
/**
 * @param {import("../types").DataGridViewConfigColumnsType} column
 * @param {string} mediaCategory
 * @returns {import("react").CSSProperties["width"]}
 */

var getColumnWidth = function getColumnWidth(column, mediaCategory) {
  if (column.hidden) return 0;
  var columnWidth = 'auto';

  if (column.width) {
    if (typeof column.width === 'number') {
      return column.width;
    } else {
      var crtIdx = bp.indexOf(mediaCategory);

      for (var i = crtIdx; i >= 0; i--) {
        if (typeof column.width[bp[i]] !== 'undefined') {
          columnWidth = column.width[bp[i]];
          break;
        }
      }
    }
  }

  return columnWidth;
};

var getColumnChildren = function getColumnChildren(column, mediaCategory) {
  if (column.children === null) return null;

  if (typeof column.children !== 'undefined') {
    var children = column.children;

    if (typeof column.children === 'object') {
      var crtIdx = bp.indexOf(mediaCategory);

      for (var i = crtIdx; i >= 0; i--) {
        if (typeof column.children[bp[i]] !== 'undefined') {
          children = column.children[bp[i]];
          break;
        }
      }

      return children;
    }

    return column.children;
  }

  if (column.icon) return React.createElement(Icon, {
    type: column.icon,
    style: {
      fontSize: '1.6em'
    }
  });
  return React.createElement(DefaultObjectFormatter, {
    data: column
  });
};

var getColumnsCount = function getColumnsCount(columns, mediaCategory) {
  return columns.filter(function (c) {
    return getColumnWidth(c, mediaCategory) !== 0;
  }).length;
};

export default {
  getColumnChildren: getColumnChildren,
  getColumnWidth: getColumnWidth,
  getColumnsCount: getColumnsCount
};